export default "/images/benu.png?c336b351599edcf6ff02910cce355b3c";